import React from 'react';
import FeedbackItem from './FeedbackItem';

export default function FeedbackList({
    feedbacks,
    currentTime,
    onSeek,
    onResolve,
    onDelete,
    onEdit,
    onReply
}) {
    if (feedbacks.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center py-12 text-gray-500 border border-dashed border-white/10 rounded-xl">
                <p>No feedback yet.</p>
                <p className="text-sm">Play the video and add your thoughts!</p>
            </div>
        );
    }

    // Find active feedback (closest to current time but not after)
    // Or maybe just highlight the one we just clicked? 
    // Typically "active" means the one corresponding to the current video time.
    // For simplicity, let's just highlight if within a small range (e.g. 2s)
    // Optimization: Pre-calculate this if lists are huge, but for <100 items it's fine.

    return (
        <div className="flex flex-col gap-3 overflow-y-auto max-h-[600px] pr-2 custom-scrollbar">
            {feedbacks.map((item) => {
                const isActive = Math.abs(item.timestamp - currentTime) < 2; // Active window 2s
                return (
                    <FeedbackItem
                        key={item.id}
                        feedback={item}
                        isActive={isActive}
                        onSeek={onSeek}
                        onResolve={onResolve}
                        onDelete={onDelete}
                        onEdit={onEdit}
                        onReply={onReply}
                    />
                );
            })}
        </div>
    );
}
